/* eslint-disable max-lines-per-function */
/* eslint-disable react/forbid-elements */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { FC, useEffect } from "react";
import { languageFromNavigator } from "../../app/miscellaneous/languageFromNavigator";
import { useState } from "../hooks/useState";
import { BreadCrumbsLanguageOption } from "./BreadCrumbsLanguageOption";
import axios from "axios";

export type Language = {
  readonly language: string;
  readonly languageIso: string;
};

export const BreadCrumbsLanguageTab: FC = () => {
  const [showLanguageDropdown, setShowLanguageDropdown] =
    useState<boolean>(false);

  const [languages, setLanguages] = useState<readonly Language[]>([]);
  const [defaultLanguage, setDefaultLanguage] = useState<string>("en");

  const getDefaultLanguage = async () => {
    await languageFromNavigator().then((result) => {
      setDefaultLanguage(result);
    });
  };

  const getLanguages = async () => {
    await axios.get("/cart/languages").then((result) => {
      setLanguages(JSON.parse(result.data));
    });
  };

  useEffect(() => {
    getDefaultLanguage();
    getLanguages();
  }, []);

  const mouseEnterHandler = () => {
    setShowLanguageDropdown(true);
  };
  const mouseLeaveHandler = () => {
    setShowLanguageDropdown(false);
  };

  return languages.length && defaultLanguage ? (
    <div
      id="mkhc-language-toggle"
      className="tw-flex before:tw-self-center before:tw-content-['|'] before:tw-mx-2 before:tw-text-xl"
    >
      <div
        className="tw-relative"
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        <BreadCrumbsLanguageOption
          languageIso={defaultLanguage}
          isOnClickDisabled={true}
          language={
            languages.find((lang) => lang.languageIso === defaultLanguage)
              ?.language
          }
        />
        {showLanguageDropdown && (
          <div
            className="tw-pt-1 tw-absolute tw-right-0 tw-z-[10001] tw-mr-[-2.8rem]"
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
          >
            {languages.length > 1 && (
              <div className="tw-py-1 tw-px-5 tw-bg-white tw-border tw-rounded-xl tw-shadow-2xl mkhc-language-dropdown">
                {languages
                  .filter((lang) => lang.languageIso !== defaultLanguage)
                  .map((lang) => (
                    <BreadCrumbsLanguageOption
                      key={lang.languageIso}
                      languageIso={lang.languageIso}
                      language={lang.language}
                    />
                  ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  ) : null;
};
